import script from "./AppLayoutSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutSidebar.vue?vue&type=style&index=0&id=58801da2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58801da2"]])

export default __exports__